import { Component, OnInit } from '@angular/core';
import axios from 'axios';
import { environment } from '../../../environments/environment';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-qualifications',
  templateUrl: './qualifications.component.html',
  styleUrls: ['./qualifications.component.scss']
})
export class QualificationsComponent implements OnInit {
  token = window.sessionStorage.getItem('token');
  userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
  loading = false;
  modal = {
    active: false,
    data: {}
  };
  userBase;
  qualifications = [];
  headings = [
    {
      label: 'Title',
      key: 'title'
    },
    {
      label: 'Acronym',
      key: 'Acronym'
    },
    {
      label: 'Function Area',
      key: 'functionArea'
    },
    {
      label: 'Active',
      key: 'friendlyActive'
    }
  ];
  settings = {
    label: 'New Qualification',
    action: 'create',
    target: 'qualifications',
    route: 'qualifications'
  };

  constructor(private toast: ToastService) {}

  async ngOnInit() {
    this.userBase = this.userInfo.basecode;
    this.refreshQualifications();
  }

  refreshQualifications = async () => {
    this.loading = true;
    let qualifications = await axios.get(environment.API_URL + '/Quals', {
      headers: { Authorization: 'Bearer ' + this.token }
    });
    this.qualifications = qualifications.data.value;
    this.qualifications.forEach((qual) => {
      qual.friendlyActive = qual.active ? 'Yes' : 'No';
    });
    this.loading = false;
  };

  modalConfirmed = (data) => {
    if (data.action === 'delete') {
      this.delete(data.qualification);
    }
    this.modal.active = false;
  };
  modalDenied = (data) => {
    this.modal.active = false;
  };

  confirmDelete = (qualification) => {
    this.modal = {
      data: {
        content: 'Are you sure you want to delete this qualification?',
        deny: 'Cancel',
        confirm: 'Delete',
        action: 'delete',
        qualification: qualification
      },
      active: true
    };
  };

  delete = async (qualification) => {
    let userId = this.userInfo.id;
    let id = '';
    if (qualification.id) {
      id = qualification.id;
    } else if (qualification.href) {
      id = qualification.href.slice(
        qualification.href.indexOf('/Quals/') + '/Quals/'.length,
        qualification.href.length
      );
    }
    axios
      .delete(
        environment.API_URL + '/Quals/' + id + '/delete?userId=' + userId,
        {
          headers: { Authorization: 'Bearer ' + this.token }
        }
      )
      .then((response) => {
        this.toast.show('Deleted Qualification', 'success');
        this.refreshQualifications();
      })
      .catch((error) => {
        if (error.response.data.detail !== null) {
          if (error.response.data.detail.startsWith('The DELETE statement conflicted with the REFERENCE constraint')) {
            this.toast.show('The Qualification is used by one or more Jumper records, and cannot be delted', 'error');
          } else {
            this.toast.show('Unable to Delete Qualification', 'error');
          }
        }
        else {
          this.toast.show('Error deleting Qualification', 'error');
        }
      });
  };
}
